export enum MetricColorName {
	SENTIMENT_3 = '_calculation_color.sentimentBreakdown3',
	SENTIMENT_5 = '_calculation_color.sentimentBreakdown5',
	EFFORT_3 = '_calculation_color.easeScoreBreakdown3',
	EFFORT_5 = '_calculation_color.easeScoreBreakdown5',
}
